import React, { useEffect, useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { ASRListItemDetails, Image } from './styles';
import { asrStrings } from './constants';
import { AsrAnalytics } from '../../../constants';

type ItemDetailsProps = {
  concern: any;
};

export const ItemDetails = ({ concern }: ItemDetailsProps) => {
  const { trackEvent } = useContext(AnalyticsContext);
  const hasMedia = concern?.issues?.some((issue: any) => issue?.media?.length > 0);

  useEffect(() => {
    const issue = concern.issues[0];
    const eventPayload = {
      dateSubmitted: concern.createdOn,
      issueType: issue.category,
      issueLocation: issue.location,
      issueCategory: issue.type,
      issueDescription: issue.details,
    };
    trackEvent(AsrAnalytics.VIEWED_REPORTED_CONCERN, eventPayload);
    datadogRum.addAction(AsrAnalytics.VIEWED_REPORTED_CONCERN, eventPayload);
  }, []);

  return (
    <>
      {concern && (
        <ASRListItemDetails>
          <div>
            <span>Date</span>
            <div>{new Date(concern?.createdOn || 0).toLocaleDateString()}</div>
          </div>
          <div>
            <span>Concern(s)</span>
            <ul>
              {concern?.issues?.map(({ id, location, category, details, media, type }: any) => (
                <div key={id}>
                  {!concern.isLegacy && (
                    <>
                      <li>
                        <span>Category</span>
                        <div>{category}</div>
                      </li>
                      <li>
                        <span>Location</span>
                        <div>{location}</div>
                      </li>
                      <li>
                        <span>Type</span>
                        <div>{type}</div>
                      </li>
                    </>
                  )}
                  {details && (
                    <li>
                      <span>Details</span>
                      <div>
                        {
                          details
                            .split(/Photo 1:.*\/managecustomerdocument\/showdocument\?documentid=/g)[0]
                            .split('Photo(s): ')[0]
                        }
                      </div>
                      {details.indexOf('expiry=') > 0 && (
                        <div>
                          {/* extract all image urls from asr dsecription, strip any leading or trailing commas, and render <img /> tags using the urls as src */}
                          {details.match(/\bhttps?:\/\/\S+/gi).map((x) => (
                            <Image src={x.replace(/^,|,$/g, '').trim()} alt="asr_photo" key={x} />
                          ))}
                        </div>
                      )}
                    </li>
                  )}
                  {media && media.length > 0 && media.map((url: any) => <Image src={url} alt="photo1" key={url} />)}
                </div>
              ))}
            </ul>
          </div>
          {concern?.issues?.length && concern.issues.length > 0 && hasMedia && (
            <div>
              {concern.sourceId === 3 ? <div>{asrStrings.outsideAdvocate}</div> : <div>{asrStrings.altText}</div>}
            </div>
          )}
        </ASRListItemDetails>
      )}
    </>
  );
};

export default ItemDetails;
